import z from "zod";

const zBuildingTypeSchema = z.enum(["PRIVATE_HOUSE", "APARTMENT", "OFFICE"]);
type BuildingTypeSchema = z.infer<typeof zBuildingTypeSchema>;

export { zBuildingTypeSchema };
export type { BuildingTypeSchema };
